<mat-form-field color="accent" subscriptSizing="dynamic">
    @if (label && label.length > 0) {
        <mat-label>{{label}}</mat-label>
    }
    <mat-select (openedChange)="onOpenedChange($event)" (selectionChange)="onSelectionChange()" [multiple]="multiple" [placeholder]="placeholder" [formControl]="selectionControl"
        [attr.aria-label]="label || placeholder">
        <mat-select-trigger>
            {{getSelectionName()}}
            @if (multiple && selectedCount > 1) {
                <span class="additional-selection">
                    (+{{selectedCount - 1}} {{selectedCount === 2 ? 'other' : 'others'}})
                </span>
            }
        </mat-select-trigger>
        @if (clearable && !multiple && selectedCount > 0) {
            <mat-option [value]="null" class="clear-option">None</mat-option>
        }
        @for (group of groups; track group._key) {
            <mat-optgroup [label]="group.name">
                @for (item of group.items; track item._key) {
                    <mat-option [value]="optionValue(group, item)">
                        <div class="select-option-image">
                            @if (item.type) {
                                <app-node-svg [type]="item.type"/>
                            }@else if (item.image) {
                                <img height="20" [src]="item.image" alt="">
                            }
                            <span>{{item.name}}</span>
                        </div>
                    </mat-option>
                }@empty {
                    <mat-option disabled>Nothing to choose</mat-option>
                }
            </mat-optgroup>
        }
    </mat-select>
    @if (hint && hint.length > 0) {
        <mat-hint>{{hint}}</mat-hint>
    }
</mat-form-field>
